<template>
  <div class="row">
    <div class="col-md-12">
      <Card :title="table1.title" :subTitle="table1.subTitle">
        <div slot="raw-content" class="table-responsive">
          <div v-if="isAdmin == 2" class="mb-3 d-flex justify-content-start ">
            <button class="btn btn-outline-default mr-3 ml-3 mt-2" @click="openUpdateStatusModal">
              <i class="ti-settings mr-2"></i> Refund Management
            </button>

          </div>
          <div class="mb-3 d-flex justify-content-end">

            <form class="form-inline">
              <div class="form-group mr-3">
                <v-select v-model="selectedOption" :options="filteredOptions" label="company_name_en"
                  placeholder="Select account" @input="handleChange" style="width: 250px;"></v-select>
              </div>

              <div class="form-group mr-3">
                <select v-model="selectedFilter"
                  class="bea-select text-sm rounded-md border-transparent placeholder-gray-400"
                  style="width: 200px; height: 38px;">
                  <option value="selected_month">Selected Month</option>
                  <option value="selected_year">Selected Year</option>
                  <option value="selected_day">Selected Day</option>

                </select>
              </div>

              <div class="form-group mr-3">
                <div v-if="selectedFilter === 'selected_day'">
                  <input type="date" v-model="searchQuery" placeholder="Select Date..."
                    class="bea-select text-sm rounded-md border-transparent placeholder-gray-400"
                    style="width: 200px; height: 38px;" />
                </div>

                <div v-else-if="selectedFilter === 'selected_month'">
                  <input type="month" v-model="searchQuery" placeholder="Select Month..."
                    class="bea-select text-sm rounded-md border-transparent placeholder-gray-400"
                    style="width: 200px; height: 38px;" />
                </div>
                <div v-else-if="selectedFilter === 'selected_year'">
                  <input type="number" v-model="searchQuery" placeholder="Select year..."
                    class="bea-select text-sm rounded-md border-transparent placeholder-gray-400"
                    style="width: 200px; height: 38px;" />
                </div>
              </div>

              <button @click="search(selectedFilter, searchQuery)" class="btn btn-outline-danger mr-2 ">
                <i class="ti-search"></i> Search
              </button>
              <button @click="reload()" class="btn btn-outline-info mr-2 ">
                <i class="ti-reload"></i>
              </button>

              <!-- <button
                  @click="getDataAndGenerateFpsPDF"
                  class="btn btn-outline-default mr-2 "
                >
                  <i class="ti-printer"></i> Print Report
                </button> -->
            </form>
          </div>
          <table class="table table-bordered">
            <thead class="bg-light  bold-text">
              <tr>
                <th class="py-2 pl-6" style="font-weight: bold;">#</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Reference Number</th>
            
                <th class="py-2 pl-6" style="font-weight: bold;">Refund from</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Received Refund</th>
                <th class="py-2 pl-6" style="width: 5%; font-weight: bold;">Currency</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Amount</th>
                
                <th class="py-2 pl-6" style="font-weight: bold;">Due Date</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Note</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Remark</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Submit By</th>

                <th class="py-2 pl-6" style="font-weight: bold;">Slip/File</th>
                <th class="py-2 pl-6" style="font-weight: bold;">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(transaction, index) in Myrefund" :key="transaction.id">
                <td class="py-2 pl-6 md-2 " style="width: 2%; ">{{ index + 1 }}</td>
                <td class="py-2 pl-6 md-2 text-left" style="width: 8%; ">{{ transaction.referent_number }}</td>
                <td class="py-2 pl-6 md-2 text-left" style="width: 15%; ">{{ transaction.s_company_name }}</td>
                <td class="py-2 pl-6 md-2 text-left" style="width: 15%; ">{{ transaction.r_company_name }}</td>
                <td class="py-2 pl-6 md-2 text-center" style="width: 5%; ">{{ transaction.currency }}</td>
                <td class="py-2 pl-6 md-2 text-center" style="width: 5%;">{{ parseFloat(transaction.amount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                
                <td class="py-2 pl-6 md-2 text-left" style="width: 10%;">{{ formatDate(transaction.dateCreate) }}</td>
                <td class="py-2 pl-6 md-2 text-left" style="width:10%;">{{ transaction.note }}</td>
                <td v-if="(transaction.status == 1 ) " class="py-2 pl-6 md-2 text-left" style="width: 15%;">- Approve by {{ transaction.approveBy }}</td>
                <td v-else-if="( transaction.status == 0 ) " class="py-2 pl-6 md-2 text-left" style="width: 15%;">-</td>
                <td v-else class="py-2 pl-6 md-2 text-left" style="width: 15%;">- Cancel by {{ transaction.approveBy }}</td>
                <td class="py-2 pl-6 md-2 text-left" style="width:10%;">- Submit by {{ transaction.submitBy }}</td>
                <td style="text-align: center; width: 5%;">
                  <button v-if="transaction.image" @click="openFileModal(getImageUrl(transaction.image))"
                    class="btn btn-outline-info">
                    <i class="ti-eye"></i> View File
                  </button>
                  <span v-else class="text-muted">No File</span>
                </td>
                <td style="text-align: center; width: 5%;">
                  <button :style="{
        backgroundColor: getStatusColor(transaction.status),
        color: 'white',
        padding: '0.5rem',
        borderRadius: '5px',
        border: '1px solid ' + getStatusColor(transaction.status),
        cursor: 'pointer'
      }" class="btn btn-outline" @click="changeStatus(transaction)"
                    :disabled="isAdmin == 2 || transaction.status === '1' || transaction.status === '2'">

                    {{ transaction.status == 1 ? 'success' : transaction.status == 0 ? 'pending' : transaction.status ==
        2 ? 'cancel' : 'cancel' }}
                  </button>
                </td>

              </tr>
            </tbody>
          </table>
          <div class="main-container">
            <!-- ... (your existing template code) ... -->
            <div class="pagination-container">
              <div v-if="currentPage > 1" @click="prevPage()" class="btn btn-outline-danger">
                Prev
              </div>
              <div v-else class="btn btn-secondary" disabled>
                Prev
              </div>
              <div class="px-4 py-2">{{ currentPage }}/{{ totalPages }}</div>
              <div v-if="currentPage == totalPages" class="btn btn-secondary" disabled>
                Next
              </div>
              <div v-else @click="nextPage()" class="btn btn-outline-danger">
                Next
              </div>
            </div>
          </div>
          <div v-if="isUpdateStatusModalOpen" class="modal-overlay" @click="closeUpdateStatusModal"></div>
          <RefundModal v-if="isUpdateStatusModalOpen" @closeModal="closeUpdateStatusModal" />
        </div>
      </Card>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { Card, PaperTable } from "@/components";
import Swal from 'sweetalert2';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import RefundModal from '@/components/Modal/RefundModal.vue';


const selectedFilter = ref('selected_month');
const baseURL = "https://api2.logizall.com";
const Myrefund = ref([]);
const Quertsearch = ref()
const token = localStorage.getItem('token');
const table1 = ref({
  title: "Refund",
  subTitle: "Refund",

});





const currentPage = ref(1);
const pageSize = 10; // Set your desired page size
const totalPages = ref(1);
const totalRecords = ref(0);
const isAdmin = ref(null);
const isSearch = ref(false);
const isUpdateStatusModalOpen = ref(false);
let searchQuery

// Method to open the update status modal
const openUpdateStatusModal = () => {
  isUpdateStatusModalOpen.value = true;
};

// Method to close the update status modal
const closeUpdateStatusModal = () => {
  isUpdateStatusModalOpen.value = false;
};

const checkAdminRole = async () => {

  try {

    const response = await axios.get('https://api2.logizall.com/auth/admin/verify-token', {
      headers: {
        Authorization: token,
      },
    });

    // Check if user is admin with role 1

    console.log("res", response.data.role_admin)
    isAdmin.value = response.data.role_admin
    // return isAdmin ;
  } catch (error) {
    console.error('Failed to check admin role:', error.message);
    return false; // Default to false if role check fails
  }
}

const changeStatus = async (transaction) => {
  const result = await Swal.fire({
    title: 'Change Status',
    text: 'Select the new status:',
    icon: 'warning',
    showCancelButton: true,
    showDenyButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Approve',
    denyButtonText: 'Denied',
    cancelButtonText: 'Cancel',
  });

  if (result.isConfirmed) {
    updateStatus(transaction, '1');
  } else if (result.isDenied) {
    updateStatus(transaction, '2');
  } else if (result.isDismissed && result.dismiss == "cancel") {
  } else {
  }
};

const updateStatus = async (transaction, newStatus) => {
  try {
    //console.log(token);
    //console.log("log", transaction.id, newStatus);

    const response = await axios.put(
      `${baseURL}/admin/refund/changeStatus/${transaction.id}`,
      {
        newStatus: newStatus,
      },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    console.log(response.data.message)

    let message = '';
    let type = '';
    if (response.data.message !== 'insufficient Balance to Refund ') {
      if (newStatus == 1) {
        message = 'The status has been changed to success successfully.';
        type = 'success';
      } else if (newStatus == 2) {
        message = 'The status has been changed to cancel.';
        type = 'success'; // Using 'error' type for the "Cancel" message
      }
      Swal.fire('Success', message, type).then(() => {
        // Reload the page after the user clicks "OK" on the success message
        window.location.reload();
      });
    } else if (response.data.message == 'insufficient Balance to Refund') {
      message = 'insufficient Balance to Refund.';
      type = 'Error';
    } else {
      message = 'Error something went wrong.';
      type = 'Error';
    }
  } catch (error) {
    console.error('Error updating status:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'An error occurred while updating the status.',
    });
  }
};



const getrefund = async () => {
  try {

    const response = await axios.get(`${baseURL}/admin/getrefund`, {
      params: {
        page: currentPage.value,
        pageSize: pageSize,
      },
      headers: {
        Authorization: token,
      },
    });
    console.log("response", response)
    Myrefund.value = response.data.data || [];
    totalPages.value = Math.ceil(response.data.totalRecords / pageSize);
    totalRecords.value = response.data.totalRecords || [];
  } catch (error) {
    console.error('Error fetching My Wallet data:', error);
    // Handle the error appropriately, e.g., show an error message to the user.
  }
};
const prevPage = () => {
  prevOrNextPage('prev');
};

const nextPage = () => {
  prevOrNextPage('next');
};

const prevOrNextPage = (action) => {
  if (action == 'prev') {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  } else if (action == 'next') {

    //console.log("pageSize",pageSize)
    //console.log("totalRecords",totalRecords.value)
    if (currentPage.value * pageSize <= totalRecords.value) {
      currentPage.value++;
    }
    //console.log("currentPage",currentPage.value)
  }


  // Check if it's a search or regular page navigation
  if (isSearch.value) {
    //console.log("isSearch",isSearch.value)
    search(selectedFilter.value, Quertsearch.value);
  } else {
    getrefund();
  }
};

const search = async (dateFilter, searchQuery) => {
  //console.log("search");
  //console.log("dateFilter", dateFilter);
  //console.log("selectedDate", searchQuery);
  Quertsearch.value = searchQuery;
  //console.log("Quertsearch", Quertsearch.value);
  //console.log("selectedOption", selectedOption.value);
  try {
    // Check if selectedFilter is null
    if (selectedOption.value === null) {
      // Perform the search using the original API
      const response = await axios.get(`${baseURL}/admin/getrefundbysearch`, {
        params: { dateFilter, selectedDate: searchQuery, page: currentPage.value, pageSize: pageSize },
        headers: {
          Authorization: token,
        },
      });

      // Destructure the response data
      const { data, total } = response.data;


      // Update values
      Myrefund.value = data || [];
      totalRecords.value = total || [];

      // Set the search flag to true
      isSearch.value = true;
      totalPages.value = Math.ceil(response.data.total / pageSize);
      // Update the current page to 1, as the search results start from the first page

    } else {
      // Perform the search using the new API
      //console.log("selectedOption.value",selectedOption.value.id)
      const response = await axios.get(`${baseURL}/admin/getrefundbysearchmid/${selectedOption.value.id}`, {
        params: { dateFilter, selectedDate: searchQuery, page: currentPage.value, pageSize: pageSize },
        headers: {
          Authorization: token,
        },
      });

      // Destructure the response data
      const { data, total } = response.data;

      // Update values
      Myrefund.value = data || [];
      totalRecords.value = total || [];

      // Set the search flag to true
      isSearch.value = true;
      totalPages.value = Math.ceil(response.data.total / pageSize);

      // Update the current page to 1, as the search results start from the first page

    }
  } catch (error) {
    console.error('Error fetching accounting data:', error);
    // Handle the error appropriately, e.g., show an error message to the user.
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'An error occurred while fetching data.',
    });
  }
};

const formatDate = (dateString) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'Asia/Bangkok',
  };
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', options);
};
const openFileModal = (fileUrl) => {
  console.log(fileUrl);
  if (fileUrl) {
    // Check if the file is an image (JPEG, PNG, GIF)
    const isImage = /\.(jpe?g|png|gif)$/i.test(fileUrl);

    if (isImage) {
      // Display the image in a smaller SweetAlert modal
      Swal.fire({
        imageUrl: fileUrl,
        imageAlt: 'Refund',
        showCloseButton: true,
        customClass: {
          popup: 'smaller-modal', // Add a custom CSS class for the modal
        },
      });
    } else {
      // Open the PDF in a new window or tab
      window.open(fileUrl, '_blank');
    }
  } else {
    // Handle the case where there is no file
    Swal.fire({
      icon: 'info',
      title: 'No File',
      text: 'There is no file available for this transaction.',
    });
  }
};


const getImageUrl = (filename) => {
  console.log("admin/images/refund/", filename)
  // Replace 'localhost:4000' with your actual server address
  return `${baseURL}/admin/images/refund/${filename}`;
};
const getStatusColor = (status) => {
  switch (status) {
    case '0':
      return 'orange';
    case '1':
      return 'green';
    case '2':
      return 'red';
    default:
      return 'red';
  }
};

const selectedOption = ref(null);
const filteredOptions = ref([]);

const handleChange = (value) => {
  // Handle the selected value here
  console.log('Selected Option:', value);
  // You can perform additional actions or update other variables as needed
};
const fetchTransfer = async () => {
  try {
    let currentPage = 1;
    let totalPages = 1;
    let allOptions = []; // เพิ่มตัวแปรเก็บข้อมูลทั้งหมด

    do {
      const response = await axios.get(`https://api.logizall.com/api/customers?pagination%5Bpage%5D=${currentPage}&pagination%5BpageSize%5D=100`);
      //console.log("response", response.data.meta.pagination.pageCount);

      totalPages = response.data.meta.pagination.pageCount;

      const options = response.data.data
        .filter(option => option.attributes.status === "bronze") // Filter out only active data
        .map(option => ({
          id: option.id,
          company_name_en: option.attributes.companyNameEn
        }));

      allOptions = allOptions.concat(options); // เพิ่ม options เข้าไปใน allOptions

      currentPage++;

    } while (currentPage <= totalPages);

    filteredOptions.value = allOptions; // ใส่ข้อมูลทั้งหมดลงใน filteredOptions.value
    //console.log(filteredOptions.value)
  } catch (error) {
    console.error('Error fetching balance types:', error);
  }
};
const reload = async () => {
  fetchTransfer();
  getrefund();
  checkAdminRole();
};
onMounted(() => {
  fetchTransfer();
  getrefund();
  checkAdminRole();
});



</script>


<style>
.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
  border-spacing: 0;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  text-align: center;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table tbody+tbody {
  border-top: 2px solid #dee2e6;
}

.search-container {
  display: flex;
  /* align-items: right; */
  margin-left: auto;
}


.pagination-container {
  display: flex;
  justify-content: flex-end;
  /* Align items at the start of the container */
  align-items: stretch;
  /* Stretch items vertically */
  text-align: center;
  /* Center text within each item */
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.smaller-modal {
  max-width: 50%;
  /* Adjust the maximum width as needed */
}

.bea-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adjust the font size as needed */
  color: #333;
  /* Text color */

  width: 200px;
}

.bea-select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  /* Adjust the font size as needed */
  color: #333;
  /* Text color */
  width: 200px;
}

.bold-text {
  font-weight: bold;
}
</style>